<template>
  <div class="c-form-control c-form-control__variant--sm">
    <v-select
      :options="users"
      :placeholder="$t('admins.searchPlaceholder')"
      :value="value"
      ref="userSearchSelect"
      @search="SEARCH_IT"
      @open="SEARCH_IT('', $refs.userSearchSelect.toggleLoading)"
      @input="$emit('input', $event)"
      label="fullname"
    >
      <template #option="item">
        <small>{{ item.fullname }}</small>
        <chip class="u-margin-left-xsmall" size="xs" variant="primary">
          {{ $t(`admins.${item.role}`) }}
        </chip>
      </template>
      <template #selected-option="item">
        <small>{{ item.fullname }}</small>
        <chip class="u-margin-left-xsmall" size="xs" variant="primary">
          {{ $t(`admins.${item.role}`) }}
        </chip>
      </template>
      <template #no-options="{}">
        <NotFound></NotFound>
      </template>
      <template #not-auth v-if="$status.user === 'NOT_AUTHORIZED'">
        <not-auth></not-auth>
      </template>
    </v-select>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Chip from "../Base/Chip.vue";
import NotFound from "../Base/NotFound.vue";
export default {
  components: {
    NotFound,
    Chip,
  },
  props: {
    value: {
      default: null,
    },
    search: {
      default: "",
    },
  },
  data() {
    return {
      users: [],
      searchValue: "",
      lazySearch: -1,
    };
  },
  methods: {
    async SEARCH_IT(search, loading) {
      this.searchValue = search;
      loading(true);
      if (this.lazySearch !== -1) clearTimeout(this.lazySearch);
      this.lazySearch = setTimeout(async () => {
        const response = await Requests.Admin.GetAll({
          query: { search: search },
        });
        this.$status.user = response.message;
        if (response.message === "OK") {
          this.users = response.data.items;
        }
        loading(false);
      }, 500);
    },
  },
  mounted() {
    this.searchValue = this.search;
  },
};
</script>

<style></style>
